import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { TransTerms } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import styled from 'styled-components';

interface Props {
	className?: string;
	onClose: () => void;
}

const InvestorTermsModal = ({ onClose, className }: Props) => {
	return (
		<Modal className={className} onClose={onClose}>
			<TransTerms i18nKey="investor_terms.text_1" />
		</Modal>
	);
};

const Styled = styled(InvestorTermsModal)`
	white-space: pre-line;

	* {
		line-height: 1.2em;
	}

	strong {
		font-weight: bold;
	}

	i {
		font-style: italic;
	}
`;

export { Styled as InvestorTermsModal };
